import {
  Redirect,
  Route,
  Switch,
  matchPath,
  useLocation
} from 'react-router-dom'

import { buildFeatureSet, canAccessRoute, getCredentials } from '../cache/auth'
import ErrorBoundary from '../components/ErrorBoundary'
import GoTopButton from '../components/goTopButton'
import { getSafeReturnUrl } from '../helpers/sessionRedirect'
import { lang } from '../localization'
import { RoleAccessManagement } from '../staticRoleManagement'
import { localizedPaths } from './localizedRoutes'

export default function PanelRoutes() {
  const { pathname } = useLocation()

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  if (pathname.includes('login') || !pathname || pathname === '/') {
    const returnUrl = getSafeReturnUrl()
    if (returnUrl) {
      // This access check is a UI AFFORDANCE, not a security control. It exists
      // so a post-login redirect does not land the user on a route their role
      // cannot render; the backend re-authorizes every request behind that
      // route regardless of what this decides. `getSafeReturnUrl` — which does
      // carry a real guarantee, the open-redirect guard — has already run.
      //
      // Strip lang prefix to get the base path for access check
      const basePath = returnUrl.replace(/^\/(en|fa)/, '')
      const hasAccess = RoleAccessManagement.some(
        (route) =>
          canAccessRoute(route, featureSet) &&
          matchPath(basePath, { path: route.route }) !== null
      )
      if (hasAccess) {
        return <Redirect to={returnUrl} />
      }
    }
    return <Redirect to={`/${lang}/home`} />
  }

  return (
    <div>
      <Switch>
        {RoleAccessManagement.filter((route) => {
          return canAccessRoute(route, featureSet)
        }).map((singleRoute) => (
          <Route
            key={singleRoute.route}
            path={localizedPaths(singleRoute.route)}
            exact={singleRoute.exact}>
            {/* Per-route, not app-root, on purpose: a screen that throws must not take the
                drawer with it, or the user has no way out but a reload.

                resetKey is the RESOLVED pathname, not the route pattern. The <Route> key
                above is the pattern, so moving between two instances of the same
                parameterised route reconciles this boundary instead of unmounting it — the
                error from item A would still be on screen while the URL says item B. */}
            <ErrorBoundary resetKey={pathname}>
              {singleRoute.component}
            </ErrorBoundary>
          </Route>
        ))}
      </Switch>
      <GoTopButton />
    </div>
  )
}
